import { MY_CATALOG } from 'constants/catalog';
import React from 'react';
import ProductList from './ProductList';

const MyCatalogList = () => {
    return <ProductList type={MY_CATALOG} />
}

export default MyCatalogList;